export enum ORDER_DASHBOARD_FILTER {
	New = 0,
	Urgent = 1,
}
